if (!customElements.get('wishlist-toggle')) {
  customElements.define(
    'wishlist-toggle',
    class extends HTMLElement {
      constructor() {
        super();

        /**
         * @type {HTMLButtonElement | null}
         */
        this.button = this.querySelector('[data-wishlist-toggle]');

        this.setupVariantChangeListener();
        this.setupEventListeners();
        this.checkWishlistState();
      }

      setupVariantChangeListener() {
        document.addEventListener('product:variant-changed', (event) => {
          if (!event.detail.variantId || this.dataset.product === undefined) return;

          const newVariantId = event.detail.variantId;

          let data = {};

          try {
            data = JSON.parse(this.dataset.product);
          } catch {
            // Failed to parse the product data
          }
          data.epi = newVariantId;
          this.dataset.product = JSON.stringify(data);
          this.checkWishlistState();
        });
      }

      setupEventListeners() {
        this.button?.addEventListener('click', () => this.handleToggle());

        if (!this._wishlistUpdatedListener) {
          this._wishlistUpdatedListener = (/** @type {CustomEvent} */ event) => {
            this.updateButtonState(event.detail.items);
          };
          document.addEventListener('wishlist:updated', this._wishlistUpdatedListener);
        }
      }

      async checkWishlistState() {
        await customElements.whenDefined('wishlist-form');

        /** @type {import('./types').WishlistForm | null} */
        const wishlistForm = document.querySelector('wishlist-form');

        if (wishlistForm) {
          this.updateButtonState(wishlistForm.cachedWishlistItems);
        }
      }

      /**
       * @param {import('./types').WishlistItem[]} items - The wishlist items to check against
       */
      updateButtonState(items) {
        if (!this.dataset.product) return;
        const productData = JSON.parse(this.dataset.product);

        const isInWishlist = items?.some((item) => item.empi == parseInt(productData.empi)) || false;

        this.setAttribute('data-is-in-wishlist', String(isInWishlist));
        this.removeAttribute('data-loading');

        const textSpan = this.querySelector('.wishlist-button-text');
        if (textSpan) {
          textSpan.textContent = isInWishlist ? 'Remove from wishlist' : 'Add to wishlist';
        }
      }

      handleToggle() {
        if (!this.dataset.product) return;

        this.setAttribute('data-loading', 'true');

        const productData = JSON.parse(this.dataset.product);

        document.dispatchEvent(
          new CustomEvent('wishlist:toggle', {
            bubbles: true,
            detail: { productData },
          }),
        );
      }
    },
  );
}
